
<template lang="pug">
  div(style="")
    slot
    el-form(ref='form' :rules="rules" label-position="top" :model='form')
      // el-form-item(label='工號' prop="id" required)
        el-input(v-model='form.id' disabled)
      el-form-item(label='手機號碼：' prop="userTel" )
        el-input(v-model='form.userTel' type="tel" maxlength="10" placeholder="0912345678")
      el-form-item(label='姓名：' prop="userName" )
        el-input(v-model='form.userName' placeholder="王大明")
      // el-form-item(label='您的Line ID：' prop="lineID")
        el-input(v-model='form.lineID' placeholder="王大明")
      el-form-item(label='常用地址1：' prop="address" )
        el-input(v-model='form.address' placeholder="台北市XX區XX路XX號XX樓")
      el-form-item(label='常用地址2：' prop="address1" )
        el-input(v-model='form.address1' placeholder="")
      p
      center
        el-checkbox(v-model='form.go_to_line' border) 進行line綁定，系統自動通知洗衣進度
     
      .cart__footer
        el-col(style="text-align: center;")
          el-button(type="primary" @click="submit") 加入會員
</template>
<script>

import { userCheck } from '@/api/user'
// 驗證
const phoneValidator = (rule, value, callback) => {
  // mail驗證方式 https://ithelp.ithome.com.tw/articles/10094951
  const phoneRule = /^[09]{2}[0-9]{8}$/
  if (value.length === 0) {
    callback(new Error('請輸入手機號碼'))
  } else if (value.search(phoneRule) === -1) {
    callback(new Error('請輸入正確手機格式'))
  } else {
    callback()
  }
}

export default {
  name: 'JoinInfo',
  data () {
    return {
      form: {
        userName: '',
        userTel: '',
        // lineID: '',
        address: '',
        address1: '',
        go_to_line: true,
      },
      rules: {
        userName: [{ required: true, message: '請輸入姓名', trigger: 'blur' }],
        userTel: [{ required: true, validator: phoneValidator, trigger: 'blur' }],
        address: [{ required: true, message: '請輸入您常用收送件地址', trigger: 'blur' }],
      },
    }
  },
  methods: {
    submit () {
      this.$refs['form'].validate(valid => {
        if (!valid) return false
        const params = {
          userTel: this.form.userTel,
        }
        userCheck(params).then((res)=>{
          if (res.data.status !== 0) {
            console.log("手機號碼已經註冊過了")
            this.$alert("您已經註冊過了，請嘗試直接登入。", "手機號碼已存在", {confirmButtonText: '確認'})
            this.$router.replace({ name: 'LoginLndex' })
            return false
          }
          console.log("手機號碼可以註冊")
          this.$emit('setData', this.form)
          this.$router.push({ name: 'JoinVerification' })
        })
      })
    },
      
  },
  created() {
    console.log('this.$route.params.phone_number',this.$route.params.phone_number)
    this.form.userTel = this.$route.params.phone_number
  },
}
</script>
<style scoped>
@media (min-width: 900px) {
  .el-form-item {
      margin: 0 6vw;
  }
}
</style>